<template lang="pug">
  .h-100
    button.video-controller__button(
      type="button",
      :data-index="dataIndex",
      @click="toggleShareScreen",
      @mouseenter="onMouseEnter",
      @mouseleave="onMouseLeave"
    )
      img.video-controller__icon(src="/static/img/app/btn-screenshare.svg")
    span.text-nowrap.video-controller__tooltip
      | {{ tooltip }}
</template>

<script>
import createPeer from '../../utils/createPeer'

export default {
  name: 'ShareScreenButton',
  props: [
    'onMouseEnter',
    'onMouseLeave',
    'dataIndex'
  ],
  data () {
    return {
      flag: false,
      toggleText: {
        true: '画面共有停止',
        false: '画面共有開始'
      },
      screenStream: null,
      room: null,
      peer: null
    }
  },
  computed: {
    tooltip () {
      return this.toggleText[String(this.flag)]
    }
  },
  methods: {
    async toggleShareScreen () {
      // 共有中で、共有ホストでないか判定
      if (this.shareUserCheck()) return

      this.flag = !this.flag
      this.room = this.$store.state.room

      if (this.flag) {
        this.screenStream = await navigator.mediaDevices.getDisplayMedia({ video: true })
          .then((response) => {
            return response
          }).catch(() => {
            // キャンセルされた場合
            this.flag = false
          })

        // キャンセルになってる可能性がある
        if (!this.flag) return

        // Skywayに接続
        this.creatPeerInstance()

        // peerに繋がったらMeshRoomに接続
        this.peer.on('open', (peerId) => {
          // usersに共有画面を追加
          this.updateShareUser(peerId)

          const options = {
            mode: 'mesh',
            stream: this.screenStream,
            videoBandwidth: 500
          }

          this.room = this.peer.joinRoom(this.room.name, options)

          // storeのshareRoomを更新
          this.$store.dispatch('updateShareRoom', { room: this.room })

          // レイアウトをサイドバーに、メイン表示のストリームを共有画面に変更
          const layout = {
            type: 'sidebar',
            mainStreamPeerId: peerId
          }
          this.$store.dispatch('updateLayout', { layout })

          // Chromeで画面外の「停止」ボタン押下時
          this.screenStream.getVideoTracks()[0].addEventListener('ended', this.close, { once: true })
        })
      } else {
        // 画面共有を停止
        this.screenStream.getVideoTracks()[0].stop()

        this.close()
      }
    },
    close () {
      // storeのshareRoomを閉じる
      this.$store.state.shareRoom.close()

      this.flag = false
    },
    creatPeerInstance () {
      this.peer = createPeer()
    },
    shareUserCheck () {
      const users = this.$store.state.users
      const shareUser = Object.values(users).find((value) => value?.shareFlag)

      // 画面共有していない
      if (!shareUser) return false

      // 画面共有中で、自分がホスト
      if (shareUser.hostPeerId === this.$store.state.peerId) return false

      // 画面共有中で、自分がホストでない
      alert('画面共有は１部屋に１画面しかできません。')
      return true
    },
    updateShareUser (peerId) {
      const payload = {
        peerId,
        data: {
          name: '共有画面',
          cameraFlag: true,
          shareFlag: true,
          hostPeerId: this.$store.state.peerId
        }
      }

      this.$store.dispatch('updateUsers', { payload })
    }
  }
}
</script>
